<div class="copyright">
    Copyright <a href="https://luminouspharma.com/" class="fa-cog fa fa-copyright" aria-label="Copyright Luminous Pharma Pvt. Ltd."></a> 2021 Luminous Pharma Pvt. Ltd. All rights reserved.
</div>
